import React from 'react';
import cn from 'classnames';

import './sort-buttons.styles.scss';

interface ISortButtons {
	isActive: boolean;
	sortByDecreasing?: boolean;
	unsorted?: boolean;
	onChangeSorting: (p: boolean) => void;
	wrapperClass?: string;
}

export const SortButtons = ({
	isActive,
	sortByDecreasing = true,
	onChangeSorting,
	unsorted = false,
	wrapperClass,
}: ISortButtons) => {
	const handleSorting = (byDecreasing: boolean) => () => {
		onChangeSorting(byDecreasing);
	};
	return (
		<div className={cn('sort-buttons', wrapperClass)}>
			<button
				type="button"
				className={cn('sort-buttons__chevron', {
					active: isActive && (unsorted || !sortByDecreasing),
				})}
				onClick={handleSorting(true)}
				disabled={!unsorted && !(isActive && !sortByDecreasing)}
			/>
			<button
				type="button"
				className={cn('sort-buttons__chevron', 'sort-buttons__chevron_down', {
					active: isActive && (unsorted || sortByDecreasing),
				})}
				onClick={handleSorting(false)}
				disabled={!unsorted && !(isActive && sortByDecreasing)}
			/>
		</div>
	);
};
